module.exports = __webpack_public_path__ + "img/umg.cf199638.png";